module.exports = {"TXTMOB_Download_PokerStars":{"id":"TXTMOB_Download_PokerStars","defaultMessage":"Descarcă {brand}","track":"Download {brand}"}}